<template>
    <div class="smis-hub-border">
        <div class="flex align-center space-between pb-3">
            <img src="@/assets/images/M3/M3Sketch/smis-hub-logo.svg" class="hub-logo">
            <div class="info-text">
                <h3 class="title">Ce este Smis® Asset Hub? </h3>
                <p>SMIS ASSET HUB SOA este super-furnizorul tău de echipamente tehnologice, echipamente IT, utilaje,
                    mobilier, mijloace fixe, autoturisme, instalații, software, componente, SaaS, servicii de webdesign
                    si software. Completează formularul de mai jos cu cât mai multe detalii. Nu livrăm servicii
                    specializate sau echipamente nișate. Furnizorii nostri sunt eMag, evoMAG, CEL.ro, Mobexpert, IKEA și
                    alți 30 de furnizori nișați (ex.: tamplarie, pergole, echipamente iluminat, echipamente pentru
                    generarea energiei electrice, etc). </p>
            </div>
        </div>
        <div class="flex align-center mt-4 mb-2">
            <ul class="border-right-list">
                <li>Plătești <strong>când</strong> vrei tu, facturi scadente până la 120 de zile</li>
                <li>Plătești exclusiv <strong>după</strong> avizarea cererilor de plată</li>
                <li>Plătești corect & <strong>eligibil</strong> - ne asigurăm noi de asta</li>
                <li>Clarificări? <strong>Răspundem</strong> în cel mai scurt timp</li>
                <li>Tot ce cumperi <strong>vine deja etichetat</strong> (identitate vizuală)</li>
                <li>Dosar <strong>de achiziție</strong> complet pregătit pentru avizare</li>
                <li>Perioadă de <strong>garanție extinsă, egală cu perioada de implementare</strong></li>
            </ul>
            <div class="info-text ml-5">
                <h3 class="big-title">Sună bine?</h3>
                <p class="big-info">Completează solicitarea ta de ofertă mai jos.</p>
                <p class="small-info">*În cazul în care nu putem transmite o ofertă pentru solicitarea ta te vom anunța
                    în cel mai scurt timp.</p>
            </div>
        </div>
        <validation-observer #default="{ invalid2 }" ref="hubObserver">
            <span class="display-none">{{ invalid2 }}</span>
            <b-form class="pt-2">
                <div class="flex space-between mobileColumn">
                    <div class="left-forms">
                        <b-form-group
                            id="email-group"
                            label="CE VREI SĂ CUMPERI?* (Cât mai multe detalii)"
                            label-for="product"
                            class="w-100 position-relative"
                        >
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                name="produs"
                            >
                                <b-form-textarea
                                    id="product"
                                    v-model="form.product"
                                    rows="5"
                                    :style="form.product ? {color: '#000000'} : ''"
                                    :state="errors.length > 0 ? false : null"
                                    placeholder="Te rugăm să ne oferi cât mai multe detalii, marcă, model, brand etc."
                                    class="w-100"
                                >
                                </b-form-textarea>
                                <small class="text-danger" style="display: block; bottom: 3px; height: inherit; right: 3px;">{{ errors[0]
                                }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group
                            id="price-group"
                            label="CARE ESTE PREȚUL ESTIMAT?* (TVA inclus)"
                            label-for="product"
                            class="w-100 position-relative"
                        >
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                name="preț estimat"
                            >
                                <b-form-input
                                    id="price"
                                    v-model="form.price"
                                    :state="errors.length > 0 ? false : null"
                                    type="number"
                                    :style="form.price ? {color: '#000000'} : ''"
                                    :formatter="formatPrice"
                                    placeholder="Preț în LEI, TVA inclus"
                                    class="w-100"
                                    @input="calculatePrice()"
                                >
                                </b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group
                            id="price-group"
                            label="LINKURI PRODUS (Ne ajută un link, ne dăm seama mai ușor ce îți dorești)"
                            label-for="link"
                            class="w-100 position-relative"
                        >
                            <validation-provider
                                #default="{ errors }"
                                rules="url"
                                name="link"
                            >
                                <b-form-input
                                    id="link"
                                    v-model="form.link_one"
                                    :style="form.link_one ? {color: '#000000'} : ''"
                                    :state="errors.length > 0 ? false : null"
                                    placeholder="www.furnizor.ro/produs/test"
                                    class="w-100 mb-2"
                                >
                                </b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group
                            id="price-group"
                            label-for="link"
                            class="w-100 position-relative"
                        >
                            <validation-provider
                                #default="{ errors }"
                                rules="url"
                                name="link"
                            >
                                <b-form-input
                                    id="price"
                                    v-model="form.link_two"
                                    :style="form.link_two ? {color: '#000000'} : ''"
                                    :state="errors.length > 0 ? false : null"
                                    placeholder="www.furnizor.ro/produs/test"
                                    class="w-100"
                                >
                                </b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </div>
                    <div class="center-forms">
                        <b-form-group
                            id="price-group"
                            label="Oferta primită prin SmisHUB"
                            label-for="link"
                            class="w-100"
                        >
                            <div class="has-prepend">
                                <b-form-input
                                    id="price"
                                    v-model="form.price_from"
                                    :style="form.price_from ? {color: '#000000'} : ''"
                                    class="w-100 mb-2"
                                    readonly
                                >
                                </b-form-input>
                                <span>de la</span>
                            </div>
                            <div class="has-prepend">
                                <b-form-input
                                    id="price"
                                    v-model="form.price_to"
                                    :style="form.price_from ? {color: '#000000'} : ''"
                                    class="w-100 mb-2"
                                    readonly
                                >
                                </b-form-input>
                                <span>până la</span>
                            </div>
                            <small>*TVA INCLUS (prețuri estimate)</small>
                        </b-form-group>
                    </div>
                    <div class="right-forms">
                        <div>
                            <p class="mb-3"><strong>SOLICITARE TRANSMISĂ DE:</strong></p>
                            <p class="mb-0">{{ form.name }}</p>
                            <p class="mb-0">Pentru {{ form.business_name.substring(0, 20) }}<span
                                v-if="form.business_name.length > 25"
                            >...</span></p>
                            <p class="mb-0">{{ form.email }}</p>
                            <p class="mb-3">{{ form.phone }}</p>

                            <p class="mb-3"><strong>CĂTRE:</strong></p>
                            <p class="mb-0">Consultant Smis<sup style="font-size: 11px">®</sup></p>
                            <p class="mb-0">{{ consultant.name }}</p>
                            <p class="mb-0">{{ consultant.email }}</p>
                        </div>
                        <div v-if="!isPaid" class="smis-hub-error mt-2">
                            <img src="@/assets/images/M3/M3Sketch/warn.png" alt="">
                            <p>Funcția Smis HUB este disponibilă exclusiv utilizatorilor licențiați.</p>
                        </div>
                        <div class="send-button-hub" @click="completeForm()">
                            <p>Trimite solicitarea în</p>
                            <img src="@/assets/images/M3/M3Sketch/hub-icon.png">
                        </div>
                    </div>
                </div>
            </b-form>
        </validation-observer>
        <p ref="scrollSmisHub" style="font-size: 13px; margin-top: 15px;">Adaos comercial practicat: <strong>10-100% /
            De ce?</strong> Pentru că Livrăm fără avans, ai termen de plată preferențial, garanție extinsă, servicii
            adiționale, consultanță inclusă.</p>
    </div>
</template>

<script>
    import {BForm, BFormRadioGroup, BFormInput, BFormTextarea, BFormGroup} from 'bootstrap-vue'
    import {ValidationProvider, ValidationObserver} from 'vee-validate'
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';

    require('@/helpers/validations/validations')
    export default {
        components: {
            BForm,
            BFormRadioGroup,
            BFormInput,
            BFormTextarea,
            BFormGroup,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            data: null,
            isPaid: null,
            justificare: null,
            descriere: null,
            price: null
        },
        data() {
            return {
                form: {
                    offers: '1',
                    product: '',
                    price: '',
                    link_one: '',
                    link_two: '',
                    price_from: '',
                    price_to: '',
                    name: '',
                    business_name: '',
                    email: '',
                    phone: '',
                    consultant_name: '',
                    consultant_email: '',
                },
                consultant: {
                    name: '',
                    email: '',
                }
            };
        },
        watch: {
            justificare: {
                handler: function() {
                    this.form.product = this.descriere + ' ' + this.justificare
                },
                immediate: true
            },
            descriere: {
                handler: function() {
                    this.form.product = this.descriere + ' ' + this.justificare
                },
                immediate: true
            },
            price: {
                handler: function() {
                    this.form.price = this.price
                    this.calculatePrice();
                },
                immediate: true
            }

        },
        mounted() {
            this.getConsultantData()
            this.form.offers = '1'
            if (this.data) {
                this.form.name = this.data.name
                this.form.business_name = this.data.business_name
                this.form.email = this.data.email
                this.form.phone = this.data.phone
            }
            this.$refs.scrollSmisHub.scrollIntoView({behavior: 'smooth', block: "center"});
        },
        methods: {
            formatPrice(e) {
                return String(e).substring(0, 20);
            },
            getConsultantData() {
                axios.get(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/consultant')
                    .then(response => {
                        if (response.data) {
                            this.consultant.name = response.data.name ? response.data.name : ''
                            this.consultant.email = response.data.email ? response.data.email : ''
							this.form.consultant_name = 'SMIS.ro'
							this.form.consultant_email = 'contact@smis.ro'
                        }
                    })
                    .catch(xhr => {
                        console.log(xhr);
                    })
            },
            calculatePrice() {
                this.form.price_from = Number(Number(this.form.price) - ((10 / 100) * this.form.price)).toFixed(2);
                this.form.price_to = Number(Number(this.form.price) + ((65 / 100) * this.form.price)).toFixed(2);
            },
            completeForm() {
                if(this.isPaid) {
                    this.$refs.hubObserver.validate().then((e) => {
                        if (!e) {
                            this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                        } else {
                            axios.post(api.API_ENDPOINTS.m3smisHub, this.form)
                                .then((response) => {
                                    this.$toast.success(response.data.message)
                                }).catch((xhr) => {
                                    if (xhr.status === 422) {
                                        this.errors.record(xhr.responseJSON.errors);
                                    }
                                    this.$toast.error(xhr.response.data.message);
                                });
                        }
                    })
                } else {
                    this.$toast.error('Funcția Smis HUB este disponibilă exclusiv utilizatorilor licențiați.');
                }
            }
        }
    };
</script>

<style scoped>
.smis-hub-error{
	display: flex;
	align-items: center;
	gap: 5px;
	width: 100%;
	animation: blinker 1.2s cubic-bezier(.5, 0, 1, 1) infinite alternate;
}
@keyframes blinker { to { opacity: 0.2; } }
.smis-hub-border {
	border-top: 2px dotted #f0f0f0;
	margin-top: 20px;
	padding-top: 20px;
}

.flex {
	display: flex;
}

.align-center {
	align-items: center;
}

h3, h2, p {
	color: #f0f0f0;
	margin: 0;
}

.title {
	font-size: 16px;
}

p {
	font-size: 12px;
}

.space-between {
	justify-content: space-between;
}

.info-text {
	max-width: 1070px;
}
.hub-logo{
    max-width: 180px;
    margin-right: 15px;
}

.border-right-list {
	padding-right: 35px;
	border-right: 2px solid #f0f0f0;
	max-width: 470px;
	font-size: 12px;
	margin: 0;
	color: #f0f0f0;
	list-style: inherit;
	padding-left: 20px;
}

.big-title {
	font-size: 58px;
	font-weight: 700;
}

.big-info {
	font-size: 23px;
	font-weight: 300;
	margin-bottom: 5px;
}

.small-info {
	font-size: 15px;
	font-weight: 300;
}

form {
	margin-top: 25px;
}

form >>> label {
	color: #f0f0f0;
	font-size: 14px;
	font-weight: 300;
}

form >>> textarea {
	border-radius: 4px;
	border: none;
	color: #aebdcd;
	background: #f0f0f0;
	font-size: 14px;
}

form >>> input {
	border-radius: 4px;
	border: none;
	color: #aebdcd;
	background: #f0f0f0;
	font-size: 14px;
}

form >>> textarea::placeholder, form >>> input::placeholder {
	opacity: 0.8;
	color: #aebdcd;
}

.left-forms {
	width: 100%;
	max-width: 680px;
}

.center-forms {
	width: 100%;
	max-width: 250px;
    padding: 0 20px;
}

.right-forms {
	width: 100%;
	max-width: 290px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.right-forms p {
	font-size: 14px;
	color: #f0f0f0;
	text-align: left;
}

.has-prepend {
	position: relative;
}

.has-prepend input {
	padding-left: 80px;
}

.has-prepend span {
	position: absolute;
	left: 7px;
	color: #aebdcd;
	opacity: 0.8;
	font-size: 14px;
	top: 0;
	bottom: 0;
	margin: auto 0;
	display: flex;
	align-items: center;
}

.center-forms small {
	color: #f0f0f0;
	font-size: 12px;
	font-weight: 300;
}

.radio-check >>> .custom-control-label:before, .radio-check >>> .custom-control-label:after {
	top: 0.17rem;
}

.send-button-hub {
	background: #f0f0f0;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	padding: 7px;
	margin-bottom: 1rem;
	cursor: pointer;
	transition: 0.4s;
}

.send-button-hub:hover {
	background: #e3dfdf;
}

.send-button-hub p {
	background: linear-gradient(to bottom, #03b3da, #038ac9);
	background-clip: text;
	-webkit-text-fill-color: transparent;
	font-weight: 700;
	font-size: 14px !important;
	margin-right: 10px;
}

.text-danger {
	position: absolute;
	display: flex;
	align-items: center;
	bottom: 0;
	height: 35px;
	right: 35px;
}

.is-invalid {
	border: 1px solid #dc3545;
}

@media (max-width: 1500px) {
	.mobileColumn {
		flex-direction: column;
	}

	.left-forms, .center-forms, .right-forms {
		max-width: 100%;
	}
    .mobileColumn >>> .center-forms{
        padding: 0 !important;
    }
}
</style>
